module.exports = __webpack_public_path__ + "img/oldOneFalse.288043da.png";